import React, { useState } from 'react';
import { FaEdit } from 'react-icons/fa';

import { useGetMe } from 'legacy/user/hooks';

import { formatPhoneNumber } from 'legacy/common/utils/phone';

import FieldSkeleton from '../FieldSkeleton';
import AddUpdatePhoneNumberFlow from './AddUpdatePhoneNumberFlow';

const PhoneNumberSettings = () => {
  const { data: user, isFetching: isFetchingUser } = useGetMe();
  const [showPhoneAddUpdateFlow, setShowPhoneAddUpdateFlow] = useState(false);

  if (isFetchingUser) {
    return <FieldSkeleton />;
  }

  return (
    <>
      <div className="flex items-center py-1 px-[12px]">
        <div className="text-base text-gray-400">Phone</div>
        <div
          className="ml-1 flex items-center mt-px text-sm text-primary-500 px-4 cursor-pointer"
          onClick={() => {
            setShowPhoneAddUpdateFlow(true);
          }}
        >
          {user?.phone ? (
            <>
              {formatPhoneNumber(user.phone)} <FaEdit className="ml-2 mb-1" />
            </>
          ) : (
            <span className="mt-px">+ Add Phone Number</span>
          )}
        </div>
      </div>

      {showPhoneAddUpdateFlow && (
        <AddUpdatePhoneNumberFlow
          onClose={() => {
            setShowPhoneAddUpdateFlow(false);
          }}
          onSuccess={() => {
            setShowPhoneAddUpdateFlow(false);
          }}
        />
      )}
    </>
  );
};

export default PhoneNumberSettings;
